{
  "account": {
    "title": "Můj účet",
    "list": {
      "title": "Účty",
      "description": "Seznam faktur připojených účtů"
    },
    "form": {
      "name": {
        "title": "Jméno",
        "description": "Název vašeho účtu"
      },
      "password": {
        "title": "Heslo",
        "description": "Nastavte nové heslo pro svůj účet; nechte prázdné pro zachování stávajícího hesla"
      },
      "emailPreferences": {
        "title": "Předvolby e-mailu",
        "description": "Vyberte typy e-mailových oznámení"
      }
    },
    "billing": "Fakturační údaje",
    "subscriptions": "Předplatná",
    "manageSubscription": "Spravovat předplatné",
    "popup": {
      "cancel": "Opravdu chcete zrušit předplatné?<br/>Váš web bude překládán až do konce stávajícího období. Poté bude překlad vypnut.<br/>Vezměte prosím na vědomí, že na nevyužité období nevzniká nárok na vrácení.",
      "downgrade": "Opravdu chcete přejít na nižší tarif? Změna bude platit okamžitě.<br/>Vezměte prosím na vědomí, že na zbývající část stávajícího fakturačního období nevzniká nárok na vrácení.<br/>Nová cena tarifu se projeví v následujícím fakturačním cyklu.",
      "default": "Opravdu chcete změnit svůj tarif?",
      "resume": "Opravdu chcete obnovit své předplatné?"
    }
  },
  "ai_translation": {
    "header": "AI překlad",
    "plan": {
      "header": "Ceny AI překladu",
      "used": "Využili jste {words_used} / {words_allowed} přeložených slov z vašich AI kreditů.",
      "remaining": "Dostupné AI kredity:",
      "words": "slov",
      "add_more_credits": "Přidat další AI kredity",
      "details": {
        "idiomatic_expressions": "Idiomatické a technické výrazy",
        "background_translation": "Překlady na pozadí",
        "best_website": "Weby vyžadující dokonalou kvalitu překladu",
        "page_context": "Kontext stránky a webu pro překlad",
        "perfect_quality": "Dokonalá kvalita, dostupná cena",
        "no_recurring": "Žádné opakované platby, předplacený limit",
        "save_40": "Ušetřete 40 % oproti tarifu 20 $",
        "save_50": "Ušetřete 50 % oproti tarifu 20 $"
      },
      "quota": "{estimated_words} slov ~ {estimated_pages} stránek"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI překlad",
        "intro": "Linguise s nadšením představuje Linguise AI překlad – novou prémiovou funkci využívající AI LLM modely (nejnovější modely Llama optimalizované pro překlad). Navržena pro weby vyžadující bezvadnou přesnost, zohledňuje kontext celé stránky i webu a nabízí bezkonkurenční výsledky. Poskytněte svým klientům vrcholnou kvalitu překladu, aby jejich sdělení dokonale rezonovalo v každém jazyce.",
        "button": "Upgradovat nyní"
      },
      "alert": {
        "description": "Tato funkce není součástí vašeho současného tarifu a vyžaduje samostatný nákup.\nAktivujte tento doplněk a odemkněte všechny níže uvedené možnosti."
      },
      "languages": {
        "title": "Použít AI překlad na jazyky",
        "description": "Vyberte konkrétní jazyky, na které se má AI překlad vztahovat"
      },
      "button": {
        "save": "Uložit nastavení"
      },
      "form": {
        "advanced": {
          "title": "Pokročilé AI instrukce",
          "description": "Pokročilé AI instrukce"
        },
        "enable_mode": {
          "title": "POVOLTIT AI PŘEKLAD",
          "description": "Zvolte, jak chcete AI překlad povolit.\nPouze pravidla použijí níže uvedená pravidla.\nPouze živý editor umožní zapínat překlad stránku po stránce z pohledu živého editoru.\nPravidla a živý editor využijí obě funkce.",
          "disabled": "Vypnuto",
          "rules": "Pouze pravidla",
          "live_editor": "Pouze živý editor",
          "all": "Pravidla a živý editor"
        },
        "rule_application": {
          "description": "Použít AI překlad na statický, dynamický nebo oba typy obsahu",
          "title": "Použít na obsah",
          "all": "Veškerý obsah",
          "static": "Statický obsah",
          "dynamic": "Dynamický obsah"
        },
        "website_topic": {
          "title": "Téma webu",
          "placeholder": "Restaurace sushi...",
          "description": "Definujte téma vašeho webu pro lepší kvalitu překladu (např. Právo, restaurace sushi, e-shop s díly na kola…)\nZadejte prosím téma webu v angličtině."
        },
        "apply_to_urls": {
          "title": "Použít na URL",
          "description": "Vyberte konkrétní URL, na která se má AI překlad vztahovat",
          "all_urls": "Všechny URL",
          "selected_urls": "Vybrané URL",
          "label": "URL pro použití",
          "placeholder": "URL pro použití",
          "wildcard": "Zástupný znak",
          "regex": "Regulární výraz",
          "add": "Přidat nový",
          "expression": "Typ výrazu"
        },
        "apply_languages": {
          "title": "Použít na jazyky",
          "description": "Vyberte konkrétní jazyky, na které se má AI překlad vztahovat",
          "all_languages": "Všechny jazyky",
          "selected_languages": "Vybrané jazyky",
          "placeholder": "Vyberte jazyky...",
          "feedback": "Musíte vybrat jazyk"
        },
        "formality": {
          "title": "Formálnost",
          "description": "Určete stupeň formálnosti v překladech, který může být důležitý pro cílové publikum a kontext.\n„Neutrální“ se pokusí zachovat formálnost původního obsahu.\n„Formální“ je pro profesionální, obchodní nebo právní obsah (např. použití formálních zájmen jako „usted“ ve španělštině).\n„Neformální“ je pro neformální, konverzační obsah (např. použití „tú“ ve španělštině).",
          "neutral": "Neutrální",
          "formal": "Formální",
          "informal": "Neformální"
        },
        "sentence_structure": {
          "classic": "Klasická",
          "short": "Krátké a výstižné věty",
          "detailed": "Podrobné a vysvětlující věty",
          "title": "Struktura vět",
          "description": "Definujte preferovaný styl psaní."
        },
        "content_purpose": {
          "marketing": "Marketingový/promo (přesvědčivý, poutavý tón)",
          "technical": "Technický/instruktážní (jasný, přesný, zaměřený na akci)",
          "support": "Zákaznická podpora (empatický, nápomocný, uklidňující)",
          "legal": "Právní/shody s předpisy (přesný, formální, nejednoznačný)",
          "educational": "Vzdělávací (jasný, strukturovaný, přístupný)",
          "other": "Jiné (v angličtině)",
          "title": "Účel obsahu",
          "description": "Definujte funkční účel obsahu, který se překládá.",
          "other_placeholder": "Popište účel..."
        },
        "target_audience": {
          "title": "Cílové publikum",
          "description": "Specifikace zamýšleného publika překládaného obsahu (v angličtině).",
          "placeholder": "např. španělsky mluvící rodiče, úředníci EU pro ochranu osobních údajů"
        },
        "override_default_translations": {
          "title": "Přepsat výchozí překlad",
          "description": "Pokud je nastaveno na ANO, bude tato volost nutit obsah k překladu přes AI (Linguise AI), i když už byl přeložen cloudovou AI (výchozí překladový model)."
        },
        "force_replace_before": {
          "title": "Vynutit opětovný překlad pomocí AI",
          "description": "Znovu přeložte pomocí AI veškerý obsah, jehož překlad pomocí AI vznikl před vybraným datem, například obsah přeložený starším modelem. K opětovnému překladu dojde při další návštěvě příslušných stránek podle pravidel a spotřebuje kredity AI.",
          "before_date": "Před datem"
        },
        "model": {
          "current": "Aktuální",
          "title": "Model",
          "description": "Vyberte model překladu LLM, který chcete použít",
          "load_error": "Nelze načíst dostupné modely. Zkuste to prosím znovu později.",
          "thinking_warning": "Tento model používá vysokou úroveň uvažování (\"myšlení\") a spotřebuje výrazně více tokenů na překlad."
        },
        "override_manual_and_selected": {
          "no_default": "Ne (výchozí)",
          "title": "Přepsat ruční a vybrané překlady",
          "description": "Ve výchozím nastavení zůstává na vašem webu vždy zobrazen ručně upravený překlad, i když je vygenerován AI vylepšený překlad. Nastavte na ANO, aby se místo něj zobrazoval AI vylepšený překlad. Vaše ruční překlady zůstanou zachovány a kdykoli se můžete vrátit zpět. To se týká také opětovného překladu stránek za účelem získání nových překladů; automaticky se použije nejnovější překlad."
        }
      },
      "message": {
        "save_success": "Z aktuálně již přeloženého obsahu by se mohlo přibližně {{ai_affected_urls}} stránek zlepšit pomocí AI překladu.",
        "save_success_only": "Nastavení byla úspěšně uložena."
      }
    },
    "pricing": {
      "plan": {
        "title": "Objednat kvótu AI překladu",
        "buy_button": "KOUPIT BALÍČEK AI PŘEKLADU"
      },
      "modal": {
        "title": "Potvrdit změnu tarifu",
        "description": "Opravdu chcete změnit svůj tarif AI překladu?",
        "button_cancel": "Zrušit",
        "button_confirm": "Potvrdit",
        "loading": "Počkejte prosím...",
        "amount": "Částka",
        "credit": "Kredit",
        "total_due": "Celkem k úhradě"
      },
      "comparison": {
        "title": "Google Cloud AI překlad\nvs Linguise AI překlad",
        "list": {
          "0": {
            "google": "Rychlé a spolehlivé překlady",
            "linguise": "Zpracování idiomatických a technických výrazů"
          },
          "1": {
            "google": "Okamžité překlady všech stránek webu",
            "linguise": "Generování překladů na pozadí"
          },
          "2": {
            "google": "Nejlepší kvalita, nízká cena",
            "linguise": "Dokonalá kvalita, cenově dostupné"
          },
          "3": {
            "google": "Ideální pro velké webové stránky nebo nízký rozpočet",
            "linguise": "Nejlepší pro web vyžadující dokonalou kvalitu překladu"
          },
          "4": {
            "google": "Kontext stránky pro překlad",
            "linguise": "Kontext stránky a celého webu pro překlad"
          }
        }
      },
      "botom_banner": {
        "title": "Zažijte bezkonkurenční přesnost překladu s",
        "sub_title": "Novým Linguise AI překladem",
        "description": "Linguise rozšiřuje své služby automatického překladu o novou možnost Linguise AI překlad – výkonné řešení využívající špičkový AI překladový LLM (nejnovější modely Llama optimalizované pro překlady). Tato novinka přináší vývojářům webů a webovým agenturám ještě vyšší úroveň kvality překladu, ideální pro projekty, kde záleží na dokonalosti. Linguise AI překlad doplňuje stávající vysoce kvalitní Google Cloud AI překlad a nabízí vám větší flexibilitu a přesnost."
      }
    },
    "success": {
      "tab_title": "Děkujeme za nákup plánu AI překlad!",
      "title": "Děkujeme za nákup plánu AI překlad!",
      "subtitle": "Váš plán AI překlad byl úspěšně zakoupen!",
      "message": "Svůj plán AI překlad můžete spravovat na stránce nastavení AI překlad.",
      "home": "Spravovat AI překlad"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Jméno",
        "description": "Název fakturačního účtu"
      },
      "phone": {
        "title": "Telefon",
        "description": "Telefon fakturačního účtu"
      },
      "email": {
        "title": "E-mail",
        "description": "E-mail fakturačního účtu"
      },
      "address": {
        "title": "Adresa",
        "description": "Adresa fakturačního účtu",
        "city": "Město",
        "country": "Země",
        "address1": "Adresa 1",
        "address2": "Adresa 2",
        "postal": "Poštovní kód",
        "state": "Stát"
      },
      "tax": {
        "title": "Daňové číslo"
      }
    }
  },
  "checkouts": {
    "header": "Platba",
    "payment_method": "Vyberte způsob platby",
    "stripe_card": "Kreditní karta (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Zadejte novou fakturační adresu",
      "existing": "Použít existující adresu"
    },
    "pay_stripe": "Potvrdit a zaplatit",
    "terms": "Potvrzením svého předplatného povolujete Linguise účtovat vám budoucí platby v souladu s našimi podmínkami. Své předplatné můžete kdykoli zrušit.",
    "coupon": {
      "title": "Máte kupón?",
      "placeholder": "Vložte kód kupónu zde",
      "apply": "Použít",
      "percent": "sleva {{0}}%"
    },
    "add_new": "Přidat nové",
    "use_existing": "Použít existující způsob platby",
    "recurring": {
      "month_single": "Účtováno měsíčně",
      "month_many": "Účtováno každé {{count}} měsíce",
      "year_single": "Účtováno ročně",
      "year_many": "Účtováno každé {{count}} let",
      "day_single": "Účtováno denně",
      "day_many": "Účtováno každých {{count}} dní",
      "week_single": "Účtováno týdně",
      "week_many": "Účtováno každých {{count}} týdnů"
    },
    "add_new_no_stripe": "Přidat novou kartu",
    "summary": {
      "title": "Souhrn",
      "subtotal": "Mezisoučet",
      "total": "Celkem"
    }
  },
  "dashboard": {
    "main": {
      "title": "Nástěnka"
    },
    "statistics": {
      "main_title": "Statistiky za posledních 30 dní",
      "characters": "Přeložené znaky",
      "words": "Přeložená slova",
      "bandwidth": "Vstupní šířka pásma",
      "request": "Požadavky",
      "page_views": "Zobrazení stránek podle jazyka (posledních 30 dní)",
      "multilingual_views": "Vícejazyčná zobrazení stránek (posledních 30 dní)",
      "most_page_viewed": "20 nejsledovanějších stránek (posledních 30 dní)",
      "no_data_yet": "Zatím nejsou k dispozici žádná data",
      "th_language": "Jazyk",
      "th_page_views": "Zobrazení stránek",
      "real_visitors": "Skuteční návštěvníci",
      "crawler": "Webový prohledávač"
    },
    "planHints": {
      "subscribeButton": "Předplatit",
      "upgradeButton": "Upgradovat",
      "usedWords": "Právě využíváte {words_used} slov",
      "noPlan": "Pro tuto doménu není aktivován žádný plán. Předplaťte si plán a začněte překládat svůj web",
      "noPlanShopify": "Pro tuto doménu není aktivován žádný plán. Předplaťte si plán na své nástěnce Shopify a začněte překládat svůj web",
      "trialUsage": "Právě využíváte {words_used} slov z {words_allowed} slov zahrnutých v zkušebním plánu.",
      "trialEnds": "1měsíční zkušební verze je aktivní do {trial_ends}.",
      "subscribeMessage": "Předplaťte si plán, než skončí, aby váš web zůstal přeložen",
      "subscribeMessageShopify": "Předplaťte si plán ze své nástěnky Shopify, než skončí, aby váš web zůstal přeložen",
      "trialReachedLimit": "Dosáhli jste maximálního počtu přeložených slov pro zkušební období.\nPředplaťte si jeden z našich plánů, abyste mohli pokračovat v překladu vašeho webu.",
      "paidUsage": "Využili jste {words_used} / {words_allowed} přeložených slov ve svém plánu.",
      "paidReachedLimit": "Dosáhli jste maximálního počtu přeložených slov pro aktuální plán.\nUpgradujte svůj plán, abyste mohli pokračovat v překladu obsahu vašeho webu.",
      "trialOfferedUsage": "Právě využíváte {words_used} slov z {words_allowed} slov zahrnutých v zkušebním plánu. (Včetně {free_words} nabídnutých slov)",
      "paidOfferedUsage": "Využili jste {words_used} / {words_allowed} přeložených slov ve svém plánu. (Včetně {free_words} nabídnutých slov)",
      "noPlanExtra": "Upozorňujeme, že neaktivní domény a jejich data jsou pravidelně automaticky odstraňovány.",
      "planRecommended": "Na základě vašeho aktuálního objemu překladu doporučujeme plán:",
      "planMaximumWords": "{{words}} slov",
      "notHaveTranslatedWords": "Zatím jste nevytvořili žádné překlady"
    },
    "translationSetup": {
      "kicker": "NASTAVENÍ SUBDOMÉNY",
      "title": "Zkontrolovat nastavení překladu",
      "description": "Zkontrolujte DNS, přeložené hostitele, přístup k původnímu webu a limity účtu.",
      "starting": "Probíhá kontrola...",
      "button": "Zkontrolovat nastavení",
      "viewLatest": "Zobrazit poslední výsledek",
      "viewCurrent": "Zobrazit aktuální kontrolu",
      "runAgain": "Spustit kontrolu znovu",
      "viewDetails": "Zobrazit podrobnosti",
      "hideDetails": "Skrýt podrobnosti",
      "error": "Nastavení nelze zkontrolovat",
      "allPassed": "Všechny kontroly prošly",
      "setupNeedsAttention": "Nastavení vyžaduje pozornost",
      "setupNeedsAttentionDescription": "Jedna nebo více kontrol selhala. Projděte níže uvedené položky nebo kontaktujte podporu Linguise.",
      "lastChecked": "Naposledy zkontrolováno {{time}}",
      "domainOwnership": "Vlastnictví domény",
      "domainOwnershipDescription": "Byl nalezen ověřovací záznam",
      "domainOwnershipFailure": "Záznam DNS pro ověření vlastnictví se nepodařilo ověřit.",
      "translatedHosts": "Přeložení hostitelé",
      "translatedHostsDescription": "Zkontrolováno jazykových hostitelů: {{count}}",
      "translatedHostsFailure": "Jeden nebo více jazykových záznamů CNAME je nesprávných.",
      "subdomainPage": "Stránka subdomény",
      "subdomainPageDescription": "{{count}} přeložených stránek přijímá HTTPS",
      "subdomainPageFailure": "Při otevírání jedné či více přeložených stránek selhalo připojení TLS.",
      "originalSite": "Původní web",
      "originalSiteDescription": "Kontroly DNS, TLS a odezvy původního webu",
      "originalSiteFailure": "Kontrola DNS, TLS nebo odezvy původního webu selhala.",
      "documentationAdvice": {
        "dns": "Zkontrolovat nastavení DNS",
        "tls": "Zkontrolovat nastavení HTTPS",
        "origin": "Zkontrolovat nastavení původního webu",
        "diagnostic": "Projděte kroky řešení potíží"
      },
      "evidence": {
        "originDns": "Původní DNS",
        "originTls": "Původní TLS",
        "originHttp": "Odpověď původního webu",
        "observedTargets": "Zjištěné cíle",
        "recordCount": "Nalezené záznamy",
        "addressCount": "Nalezené adresy",
        "statusCode": "Stav HTTP",
        "redirect": "Přesměrování",
        "expiresAt": "Platnost certifikátu vyprší",
        "raw": "{{key}}",
        "noValue": "Žádná hodnota"
      },
      "checkerError": "Některé kontroly se nepodařilo dokončit.",
      "coreLocation": "Zkontrolováno z místa {{location}}",
      "status": {
        "queued": "Ve frontě",
        "running": "Probíhá",
        "completed": "Dokončeno",
        "failed": "Selhalo",
        "passed": "Úspěšné",
        "warning": "Varování",
        "unknown": "Neznámé",
        "skipped": "Přeskočeno",
        "not_applicable": "Nevztahuje se"
      }
    },
    "throttling": {
      "title": "Omezení překladu",
      "description": "Dočasné limity využití",
      "unavailable": "Dočasné limity překladu nejsou dostupné",
      "window": "{{used}} / {{max}} slov",
      "resetsIn": "Obnovení za {{time}}",
      "throttled": "Překlad je dočasně pozastaven",
      "throttledDescription": "Bylo dosaženo dočasného limitu využití. Překlad bude pokračovat po obnovení tohoto limitu."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "KROK {{step}} Z {{total}}",
      "doneLabel": "HOTOVO, MŮŽETE ZAČÍT PŘEKLÁDAT!",
      "finish": {
        "title": "",
        "description": "Toto je API klíč, který použijete na svém webu"
      },
      "instructions": "Instrukce k instalaci",
      "domainSetting": "Nastavení domény",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "Skript PHP",
        "wizardWordpressStep1": "1. Nainstalujte ",
        "wizardWordpressStep2": "\n 2. V nastavení pluginu zkopírujte a vložte svůj API klíč\n",
        "wizardWordpressStep3": "3. Jste připraveni překládat\n\n",
        "wizardWordpressStep4": "Pro podrobnější instrukce se prosím podívejte do naší dokumentace: ",
        "wizardJoomlaStep1": "1. Odkaz na Joomla balíček: ",
        "wizardJoomlaStep2": "\n2. V nastavení rozšíření zkopírujte a vyplňte svůj API klíč",
        "wizardJoomlaStep3": "3. V konfiguraci modulu nastavte jazyky, které chcete zobrazit, a vložte modul tam, kde ho potřebujete.",
        "wizardJoomlaStep4": "\n 4. Jste připraveni překládat\n\n",
        "wizardPhpStep1": "1. Stáhněte si náš php skript a zde ",
        "wizardPhpStep2": "\n2. Postupujte podle instalačních pokynů na naší dokumentační stránce zde ",
        "wizardPhpStep3": "\n3. Přidejte modul do svých stránek.",
        "wizardPhpStep4": "\nZkopírujte následující kód a vložte ho do hlavičky své html stránky; automaticky se zobrazí přepínač modulu\n",
        "dispatchStep1": "Požadovaná data jsme úspěšně odeslali do pluginu Linguise, nyní můžete následující okno zavřít.",
        "dispatchStep2": "V případě, že token při zavření tohoto okna chybí, zkopírujte prosím následující token:",
        "dispatchStep3": "Také můžete zkopírovat tento snippet, abyste automaticky povolili náš přepínač vlaječek",
        "wizardOtherStep1": "Postupujte podle níže uvedených pokynů, abyste nainstalovali Linguise do vaší domény.\n",
        "wizardOtherStep2": "Zkopírujte následující kód a vložte ho do hlavičky své html stránky; automaticky se zobrazí přepínač modulu.\n"
      },
      "trialAlreadyUsed": "Vypadá to, že jste již využili svou bezplatnou zkušební verzi, takže potřebujete získat překladovou kvótu\nPředplaťte si prosím plán, nebo nás kontaktujte, pokud potřebujete prodloužit zkušební verzi.",
      "usefulLinks": "Užitečné odkazy pro začátek",
      "linkDocumentation": "Dokumentace",
      "linkExtensionDl": "Stažení rozšíření",
      "linkSubscribe": "Předplaťte si plán nyní",
      "linkDashboard": "Přejít na nástěnku",
      "exclusion": {
        "title": "Názvy firem a produktů",
        "description": ""
      },
      "finishButton": "Dokončit nastavení",
      "subdomains": "Subdomény",
      "subdomain_setup": "Nastavit doménu",
      "subdomain_auto_setup": "Připojit DNS automaticky",
      "subdomain_manual_setup": "Přidat DNS záznamy manuálně",
      "subdomain_skip": "Udělám později",
      "auto_subdomains_info": "Váš tvůrce webových stránek vyžaduje konfiguraci DNS pro nastavení jazyků podle subdomén (např. cs.domain.com).",
      "auto_subdomains_info_2": "To můžete provést automaticky pomocí Entri. Stačí kliknout na tlačítko \"Připojit DNS automaticky\" a začít připojovat ke svému správci DNS a přidat je pomocí Entri.",
      "auto_subdomains_info_manual": "Nebo můžete doménu nakonfigurovat ručně kliknutím na tlačítko \"Přidat DNS záznamy manuálně\".",
      "breadcrumbs": {
        "step1": "Krok 1: Doména, CMS a jazyky",
        "step2": "Krok 2: Jazykový DNS",
        "step3": "Krok {{step}}: Pokyny k instalaci"
      }
    },
    "form": {
      "urls": {
        "dash": "Pomlčka -",
        "underscore": "Podtržítko _",
        "title": "Překládat URL",
        "description": "Chcete překládat na všech stránkách",
        "char_description": "Znak použitý k nahrazení neautorizovaných znaků v URL",
        "advertisement_title": "⚠ Nastavili jste hodně jazyků.\n",
        "advertisement": "Obvykle doporučujeme začít překládat webové stránky nejprve s několika málo jazyky. Získáte představu, kolik slov vaše webová stránka má. Je to také lepší pro SEO, protože boti Google budou procházet vaše stránky rychleji, pokud jich máte nejprve méně. Po týdnu můžete přidat další jazyky a tak dále."
      },
      "url": {
        "title": "Url",
        "description": "Vložte URL vaší hlavní domény začínající na http:// nebo https://",
        "placeholder": "URL domény",
        "advertisement_http": {
          "title": "Nepoužíváte protokol https",
          "description": "Zkontrolujte prosím, zda vaše doména ve skutečnosti nepoužívá protokol https, který je dnes doporučován."
        },
        "advertisement_www": {
          "title": "Vaší subdoménou není www",
          "description": "Většinou je výchozí subdoména www (např. https://www.mojedomena.cz). Nemusí to být váš případ, ale prosím zkontrolujte, zda doména, kterou chcete přidat, je ta správná."
        },
        "invalid_url": {
          "line1": "Nepodařilo se nám najít vaši doménu. Zkontrolujte prosím, zda je vaše doména veřejně přístupná přes Internet a není přesměrována jinam.",
          "line2": "Pokud jste si jisti, že je vaše doména přístupná, můžete přeskočit ověření domény a znovu stisknout tlačítko \"Další krok\"",
          "contact": "V každém případě nás můžete kontaktovat na",
          "force": "Přeskočit ověření domény"
        },
        "invalid_subdomain_url": "Tato adresa URL není povolena. Subdomény musí být ve formátu: https://www.domain.tld nebo https://domain.tld bez podadresáře."
      },
      "account": {
        "title": "Účet",
        "description": "Vyberte účet, kterému chcete tuto doménu přiřadit",
        "placeholder": "Vyberte účet...",
        "feedback": "Musíte zvolit účet"
      },
      "platform": {
        "title": "Platforma",
        "description": "Vyberte prosím platformu vašich webových stránek podle názvu CMS.",
        "learn": "Naučte se, jak ji vybrat",
        "placeholder": "Hledat platformu podle názvu CMS...",
        "info": {
          "title": "⚠ Tato platforma byla přidána nedávno.\n",
          "desc": "Tato platforma pro tvorbu webových stránek je podporována Linguise, i když byla přidána nedávno. Pokud narazíte na jakýkoli problém, kontaktujte nás prosím pomocí přímé podpory e-mailem:"
        },
        "description_read_only": "Platforma, kterou vaše webová stránka používá",
        "feedback": "Musíte zvolit platformu"
      },
      "language": {
        "title": "Jazyk",
        "description": "Vyberte základní jazyk vašich webových stránek",
        "placeholder": "Vyberte jazyk...",
        "feedback": "Musíte zvolit jazyk",
        "description_read_only": "Základní jazyk vašich webových stránek"
      },
      "token": {
        "title": "API klíč",
        "description": "Toto je API klíč, který zkopírujete na svůj web",
        "copy": "Kopírovat do schránky",
        "reset": "Resetovat API klíč",
        "reset_confirm": "Potvrďte prosím reset API klíče"
      },
      "languages": {
        "title": "Překladové jazyky",
        "description": "Vyberte jazyky, do kterých chcete, aby byla vaše webová stránka přeložitelná",
        "placeholder": "Vyberte jazyky...",
        "feedback": "Musíte zvolit jazyk"
      },
      "defaultRules": {
        "title": "Výchozí pravidla",
        "description": "Definovali jsme sadu pravidel, která musí být použita pro zlepšení překladu a zabránění nežádoucímu obsahu k překladu, například WordPress administraci.\nTato pravidla můžete později odstranit nebo upravit, pokud si budete přát."
      },
      "disallow_deletion": "Nemůžete smazat doménu s aktivním předplatným",
      "delete_confirm": "Potvrďte prosím smazání domény",
      "delete": "Smazat doménu",
      "dynamic": {
        "title": "Překládat dynamický obsah",
        "description": "Dynamický obsah generovaný JavaScriptem a AJAX požadavky bude přeložen (Tato možnost zvýší vaše využití překladů)"
      },
      "partial_translations": {
        "title": "Povolit částečný překlad",
        "description": "Pokud váš účet dosáhl své překladové kvóty, ale stránka stále vyžaduje překlad, Linguise může pokračovat v zobrazování stránky s obsahem, který již byl přeložen.\nNěkteré části stránky však zůstanou nepřeložené, dokud nezvýšíte svou kvótu.\n\nZatímco malé množství nepřeloženého obsahu obvykle neuškodí SEO, povolení příliš mnoha nepřeložených částí by mohlo negativně ovlivnit uživatelskou zkušenost.\nPro řešení toho můžete nastavit práh pro procento nepřeloženého obsahu povoleného na stránce. Pokud nepřeložený obsah překročí tento práh, uživatelé budou automaticky přesměrováni na původní jazykovou verzi stránky.",
        "never": "Nikdy"
      },
      "translate_error_pages": {
        "title": "Překládat chybové stránky",
        "description": "Linguise může překládat všechny chybové stránky, nicméně pokud vaše chybová stránka obsahuje dynamický obsah, jako IP adresu nebo ID požadavku, měli byste se vyhnout překladu těchto stránek.",
        "not_found_page": {
          "title": "Překládat stránku 404"
        },
        "error_page": {
          "title": "Překládat ostatní chybové stránky"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Nalezena existující doména",
          "description": "Pro tohoto uživatele byla nalezena existující doména, chcete ji použít?"
        }
      },
      "search_tl": {
        "title": "Hledat překlady",
        "description": "Povolit vyhledávání překladů pro vaši platformu webových stránek (Experimentální, tato možnost zvýší vaše využití překladů)"
      },
      "shopify_promo": {
        "info": "Dobrá zpráva! Nyní máme nativní aplikaci Shopify, kterou si můžete nainstalovat z obchodu Shopify App Store.",
        "hyperlink": "Klikněte zde a spusťte instalaci Linguise z aplikace.",
        "next_btn": "Přejděte do obchodu Shopify a nainstalujte si aplikaci",
        "info_legacy": "Dobrá zpráva! Nyní máme nativní aplikaci Shopify, kterou si můžete nainstalovat z obchodu Shopify App Store.",
        "description_legacy": "Vyberte platformu „Shopify“ místo „Shopify Legacy“"
      },
      "wix_promo": {
        "info": "Dobrá zpráva! Nyní máme nativní aplikaci Wix, kterou si můžete nainstalovat z obchodu Wix App Market.",
        "hyperlink": "Klikněte zde a spusťte instalaci Linguise z aplikace.",
        "next_btn": "Přejděte do Wix App Market a nainstalujte si aplikaci",
        "info_legacy": "Dobrá zpráva! Nyní máme nativní aplikaci Wix, kterou si můžete nainstalovat z obchodu Wix App Market.",
        "description_legacy": "Vyberte platformu „Wix“ místo „Wix Legacy“"
      },
      "ai_disallow_deletion": "Tuto doménu nemůžete smazat, dokud je kvóta AI stále dostupná.\n\nPokud chcete tuto doménu smazat, kontaktujte prosím náš tým podpory na adrese",
      "language_removal": {
        "card": {
          "title": "Smazat překlady odebraných jazyků",
          "description": "Tyto jazyky byly z vašeho webu odebrány, jejich uložené překlady se však stále započítávají do kvóty. Smažte je a získejte slova zpět.",
          "button": "Smazat překlady"
        },
        "hint": "Použitá slova se vrátí do vaší kvóty. Na každém webu to můžete provést jednou za {{days}} dní.",
        "modal": {
          "title": "Smazat překlady?",
          "intro": "Tyto překlady budou trvale smazány:",
          "warning": "Tuto akci nelze vrátit zpět. Použitá slova se vrátí do vaší kvóty, což může trvat několik minut.",
          "limit": "Na každém webu to můžete provést jednou za {{days}} dní.",
          "confirm": "Smazat překlady"
        },
        "scheduled": "Překlady se odstraňují a vaše kvóta bude brzy aktualizována.",
        "cooldown": "Překlady tohoto webu byly nedávno smazány. Znovu je můžete smazat dne {{date}}.",
        "latest_completed": {
          "title": "Poslední dokončené smazání",
          "description": "Zkontrolujte smazané jazyky a počet slov vrácených do kvóty.",
          "languages": "Smazané jazyky",
          "words_returned": "Slova vrácená do kvóty: {{words}}",
          "completed_at": "Dokončeno {{date}}"
        },
        "status": {
          "recent_title": "Nedávné smazání překladů",
          "recent_description": "Sledujte poslední smazání a zjistěte, kdy bude možné další.",
          "progress_title": "Průběh mazání",
          "loading": "Kontroluje se průběh mazání...",
          "unavailable": "Průběh mazání se nepodařilo načíst. Obnovte stránku a zkuste to znovu.",
          "label": "Stav",
          "pending": "Ve frontě",
          "processing": "Probíhá",
          "completed": "Dokončeno",
          "failed": "Selhalo",
          "unknown": "Stav není k dispozici",
          "percent": "Dokončeno na {{percent}} %",
          "current_stage": "Aktuální krok: {{stage}}",
          "processed": "Zpracováno záznamů: {{processed}}",
          "processed_total": "Zpracováno {{processed}} z {{total}} záznamů",
          "requested_at": "Vyžádáno {{date}}",
          "started_at": "Zahájeno {{date}}",
          "completed_at": "Dokončeno {{date}}",
          "cooldown_period": "Na každém webu to můžete provést jednou za {{days}} dní.",
          "cooldown_blocked": "Další mazání zatím nelze spustit.",
          "stage": {
            "queued": "Čeká na zahájení",
            "processing": "Probíhá",
            "refund_summary": "Počítají se vrácená slova",
            "search_translations": "Mažou se překlady vyhledávání",
            "url_translations": "Mažou se překlady URL",
            "translations": "Mažou se překlady",
            "completed": "Dokončeno",
            "failed": "Selhalo",
            "unknown": "Probíhá"
          }
        },
        "forbidden": "Nemáte oprávnění mazat překlady."
      }
    },
    "main": {
      "edit": "Upravit doménu",
      "add": "Přidat doménu",
      "wizard": "Vítejte! Průvodce vytvořením nové domény",
      "common": "Doména"
    },
    "notice": {
      "broken_card": "Nepodařilo se nám obnovit váš plán pro {{url}} pomocí aktuální platební metody, aktualizujte prosím platební kartu",
      "quota_reached": "Vaše překladová kvóta pro {{url}} byla dosažena, upgradujte prosím, abyste obnovili překlad vašich webových stránek",
      "ai_no_subscription": "AI překlad pro {{url}} vyžaduje aktivní předplatné nebo aktivní zkušební verzi. Bez něj se zastaví, upgradujte prosím pro pokračování",
      "important": "Důležité",
      "quota_reached_button": "Upgradujte svůj tarif nyní",
      "broken_card_button": "Aktualizujte svou platební kartu",
      "ai_no_subscription_button": "Upgradujte svůj tarif nyní",
      "quota_warning": "Vaše kvóta překladů pro {{url}} dosáhla {{throttling_used_percent}} %, tato hodnota se vynuluje za {{ttl}}.",
      "locked": "Doména {{url}} je aktuálně uzamčena pro migraci, stále máte přístup ke svému webu, ale nemůžete upravovat ani přidávat nové překlady!"
    },
    "subdomains": {
      "config_ok": "DNS subdomén bylo správně nakonfigurováno.",
      "config_invalid": "DNS subdomén vyžaduje další konfiguraci, aby fungovalo.",
      "config_check": "Kontroluje se konfigurace DNS subdomén, čekejte prosím...",
      "entri_timeout": "Entri hlásí, že proces propagace DNS vašich subdomén vypršel; musíte to zkusit znovu nebo to provést ručně.",
      "entri_process": "Vaše DNS byla přidána přes Entri a obvykle trvá 10–30 minut, než se propagují (aplikují se všechny vaše jazykové subdomény jako cs.domain.com). Pokud validace DNS nebude dokončena do 24 hodin, kontaktujte náš support: support@linguise.com",
      "entri_ok": "Propagace DNS probíhá! Čeká se na dokončení...",
      "infos": "Pro aktivaci překladu musíte tyto položky DNS přidat do záznamů DNS domény. Po dokončení klikněte na tlačítko zaškrtnutí. Je možné, že šíření záznamů DNS může nějakou dobu trvat, takže se budete muset po několika minutách nebo hodinách vrátit.",
      "check": "Zkontrolujte konfiguraci DNS"
    },
    "subscription": {
      "next_payment_amount": "Nadcházející poplatky",
      "next_payment_date": "Datum příští platby",
      "invoice": {
        "header": "Historie faktur",
        "date": "Datum",
        "amount_due": "Částka",
        "status": "Stav",
        "actions": "Akce",
        "description": "Jakmile budou transakce k dispozici, uvidíte je zde.",
        "status_text": {
          "draft": "Koncept",
          "failed": "Selhalo",
          "open": "Čeká na zaplacení",
          "paid": "Zaplaceno",
          "retrying": "Opakuje se",
          "uncollectible": "Nevyinkasovatelné",
          "void": "Neplatné"
        },
        "view": "Zobrazit",
        "empty": "Pro toto předplatné nebyly nalezeny žádné nedávné faktury",
        "retry_payment": "Zkusit znovu"
      },
      "next_cancellation": "Datum zrušení",
      "cancel": "Zrušit předplatné",
      "change_plan": "Změnit tarif",
      "change": "Změnit",
      "suspend": "Pozastavit platby",
      "resume": "Obnovit předplatné",
      "back": "Zpět",
      "save": "Uložit",
      "confirm_resume": "Opravdu chcete obnovit toto předplatné?",
      "confirm_cancel": "Opravdu chcete zrušit toto předplatné?",
      "confirm_header": "Jste si jisti?",
      "missing_status": "Toto předplatné chybí",
      "not_found": "Pro tuto doménu nebylo nalezeno žádné předplatné",
      "confirm_manual_retry": "Opravdu chcete znovu zkusit tuto platbu?",
      "no_payment_method": "Neznámé",
      "remove_billing": "Odebrat",
      "shopify_maneged": "Toto předplatné spravuje Shopify. Spravujte ho prosím ve svém Shopify admin panelu.",
      "unknown_plan": "Neznámý plán"
    }
  },
  "domain_listing": {
    "add": "Přidat web",
    "select": "Vyberte doménu"
  },
  "editable": {
    "number": "číslo {{id}}"
  },
  "footer": {
    "about": "O nás",
    "support": "Podpora"
  },
  "frontendEditor": {
    "main": "Živý editor",
    "description": "Živý editor vám umožňuje přímo editovat překlady na vašem webu.",
    "button": "Otevřít živý editor",
    "language_selection": "Výběr jazyka překladu",
    "video_label": "Naučte se používat živý editor"
  },
  "general": {
    "403": {
      "tab_title": "Jejda - Chyba 403",
      "title": "Přístup zamítnut",
      "message": "Zdá se, že nemáte přístup k požadované stránce.",
      "home": "Zpět na úvod"
    },
    "404": {
      "tab_title": "Jejda - Chyba 404",
      "title": "Stránka nenalezena",
      "message": "Vypadá to, že jste se někde sekli. Nevadí... stává se to i těm nejlepším. Tady je malá rada, jak se vrátit zpátky.",
      "home": "Zpět na úvod"
    },
    "500": {
      "tab_title": "Chyba 500",
      "title": "Vnitřní chyba serveru",
      "message": "Zkuste stránku obnovit, nebo nás kontaktujte",
      "home": "Zpět na úvod"
    },
    "fields": {
      "alert": "Některá pole nejsou platná; opravte prosím neplatná pole.",
      "invalid": "Toto pole je neplatné",
      "phone_re": "Telefonní číslo je neplatné",
      "phone_invalid": "Telefonní číslo je neplatné",
      "email": "Pole E-mail je neplatné"
    },
    "table": {
      "no_data": "Zatím tu nejsou žádná data..."
    },
    "saving": "Ukládání...",
    "save": "Uložit",
    "save_and_quit": "Uložit a ukončit",
    "invite": "Pozvat",
    "cancel": "Zrušit",
    "yes": "Ano",
    "no": "Ne",
    "nextStep": "Další krok",
    "loading": "Počkejte prosím, aplikace se načítá",
    "goback": "Jít zpět",
    "manage": "Spravovat",
    "delete": "Smazat",
    "deleting": "Odstraňování...",
    "confirm": "Potvrdit",
    "unknown": "Neznámé",
    "hide": "Skrýt",
    "show": "Zobrazit",
    "on": "Na",
    "off": "Vypnuto",
    "default": "Výchozí"
  },
  "home": {
    "header": "Domů",
    "manage": "Spravovat předplatné",
    "canceled": "Naplánováno ke zrušení",
    "activate_now": "Aktivovat nyní",
    "activate_plan_now": "Předplatit nyní",
    "upgrade_plan_now": "Upgradovat tarif nyní",
    "trial_message_part_1": "Právě využíváte zkušební tarif, ",
    "trial_message_part_2": "kdykoli můžete aktivovat plné členství.",
    "add": "Přidat doménu",
    "table": {
      "title": "Domény",
      "description": "Seznam vašich domén; klikněte na doménu pro správu překladů"
    },
    "domains": {
      "empty": "V tomto účtu nemáte žádné domény"
    },
    "accountsList": {
      "title": "Účty",
      "add": "Přidat nový účet",
      "name": "Název účtu"
    },
    "update_credit_card": "Aktualizovat údaje o kreditní kartě",
    "cancelling_subs": "Zrušení v {{0}}",
    "resume_subscription": "Obnovit předplatné",
    "shopify_managed": "Spravováno Shopify",
    "trial_ends_at": "Končí v {{0}}",
    "free_trial": "Bezplatná zkušební verze",
    "no_subs": "Žádné aktivní předplatné"
  },
  "invoices": {
    "title": "Faktury",
    "list": {
      "title": "Seznam faktur"
    },
    "table": {
      "customer": "Zákazník",
      "domain": "Doména",
      "amountPaid": "Uhrazená částka",
      "status": "Stav",
      "date": "Datum",
      "invoice": "Faktura",
      "pay": "Zaplatit fakturu",
      "actions": "Akce",
      "deleted_domain": "Doména smazána",
      "plan_name": "Plán",
      "action": "Akce"
    },
    "listPending": {
      "title": "Seznam čekajících faktur"
    }
  },
  "language_settings": {
    "display": "Zobrazení seznamu jazyků",
    "position": "Pozice",
    "display_help_text": "Zobrazit vlajku a/nebo názvy jazyků. Výchozí pozice přepínače jazyka může být kdekoli v obsahu nebo v pevné pozici, která zůstává pevná nebo se pohybuje při posunu stránky",
    "side_by_side": "Vedle sebe",
    "dropdown": "Rozbalovací nabídka",
    "popup": "Vyskakovací okno",
    "flag": "Vlajka",
    "lang_name": "Název jazyka",
    "lang_short_name": "Zkrácené názvy",
    "positions": {
      "in_place": "Na místě",
      "top_left": "Vlevo nahoře",
      "top_left_no_scroll": "Vlevo nahoře (bez posunu)",
      "top_right": "Vpravo nahoře",
      "top_right_no_scroll": "Vpravo nahoře (bez posunu)",
      "bottom_left": "Vlevo dole",
      "bottom_left_no_scroll": "Vlevo dole (bez posunu)",
      "bottom_right": "Vpravo dole",
      "bottom_right_no_scroll": "Vpravo dole (bez posunu)"
    },
    "lang_names_display": {
      "title": "Zobrazení názvů jazyků",
      "help_text": "V přepínači jazyků zobrazte názvy jazyků v angličtině nebo v původním jazyce, tj. French nebo Français",
      "english": "Angličtina",
      "native_languages": "Původní jazyky"
    },
    "flag_shape": {
      "title": "Styl vlajky",
      "help_text": "Použijte kulaté nebo obdélníkové svg ikony vlajek",
      "round": "Kulaté",
      "rectangular": "Obdélníkové"
    },
    "english_flag_type": {
      "title": "Typ anglické vlajky",
      "help_text": "Pro angličtinu použijte vlajku Velké Británie nebo USA",
      "usa": "Vlajka USA",
      "great_britain": "Vlajka Velké Británie"
    },
    "german_flag_type": {
      "title": "Typ německé vlajky",
      "help_text": "Pro němčinu použijte vlajku Rakouska nebo Německa",
      "german": "Německá vlajka",
      "austria": "Rakouská vlajka"
    },
    "spain_flag_type": {
      "title": "Typ španělské vlajky",
      "help_text": "Pro španělštinu použijte vlajku Mexika nebo Španělska",
      "spanish": "Španělská vlajka",
      "mexico": "Vlajka Mexika",
      "peruvian": "Peruánská vlajka"
    },
    "portugal_flag_type": {
      "title": "Typ portugalské vlajky",
      "help_text": "Pro portugalštinu použijte vlajku Portugalska nebo Brazílie",
      "portugal": "Portugalská vlajka",
      "brazil": "Brazílie vlajka"
    },
    "taiwanese_flag_type": {
      "title": "Typ tchajwanské vlajky",
      "help_text": "Pro tchajwanštinu použijte vlajku Tchaj-wanu nebo Číny",
      "taiwanese": "Tchajwanská vlajka",
      "chinese": "Čínská vlajka"
    },
    "flag_border_radius": {
      "title": "Zaoblení hran vlajky (px)",
      "help_text": "Při použití obdélníkového tvaru vlajky můžete použít vlastní zaoblení hran v pixelech"
    },
    "flag_width": {
      "title": "Velikost vlajky (px)",
      "help_text": "Vyberte velikost vlajek v pixelech. Velikost obrázku se nemění, protože je ve formátu .svg"
    },
    "lang_color": {
      "color_title": "Barva názvu jazyka",
      "color_help_text": "Vyberte výchozí barvu textu pro názvy jazyků",
      "hover_color_title": "Barva názvu jazyka při najetí",
      "hover_color_help_text": "Vyberte barvu textu při najetí myší pro názvy jazyků",
      "color_popup_title": "Barva jazyka ve vyskakovacím okně",
      "color_popup_help_text": "Barva názvu jazyka ve vyskakovacích nebo rozbalovacích oblastech",
      "hover_color_popup_title": "Barva jazyka při najetí ve vyskakovacím okně",
      "hover_color_popup_help_text": "Vyberte barvu textu při najetí myší pro název jazyka ve vyskakovacích nebo rozbalovacích oblastech"
    },
    "flag_box_shadow": {
      "shadow_title": "Stín vlajky",
      "shadow_help_text": "Barva a velikost stínu pro jazykové vlajky",
      "hover_shadow_title": "Stín vlajky při najetí",
      "hover_shadow_help_text": "Barva a velikost stínu pro jazykové vlajky při najetí myší",
      "shadow_h_offset": "Vodorovný posun stínu (px)",
      "shadow_v_offset": "Svislý posun stínu (px)",
      "shadow_blur": "Rozmazání stínu (px)",
      "shadow_spread": "Rozlití stínu (px)",
      "shadow_color": "Barva stínu"
    },
    "order": "Pořadí jazyků",
    "language_order_help": "Pořadí jazyků, které se zobrazí v přepínači jazyků. Pořadí můžete změnit tažením a upuštěním.",
    "order_reset": "Obnovit pořadí",
    "language_order_dragdrop": "Pořadí můžete změnit tažením a upuštěním.",
    "popup_lang_name": "Název jazyka ve vyskakovacím okně",
    "preview": "Náhled jazyka"
  },
  "link": {
    "form": {
      "original": {
        "title": "Původní zdroj",
        "description": "Přidejte původní odkaz URL a níže ho nahraďte podle jazyka pro překlad",
        "srcset_description": "Upravujete URL obrázku. Přečtěte si dokumentaci, zejména pokud používáte srcset nebo nevíte, co to je",
        "link": "Odkaz",
        "match_link": "Režim shody",
        "match_exact": "Přesná",
        "match_wildcard": "Zástupný znak",
        "match_regex": "Regulární výraz"
      },
      "alternative_languages": {
        "title": "Odkazy k nahrazení",
        "description": "Nahraďte mediální a externí odkazy na všech vašich stránkách podle jazyka…",
        "link": "Odkaz k nahrazení"
      },
      "error": {
        "atLeastOne": "Přidejte alespoň jeden překlad.",
        "url": "URL je neplatná",
        "extension": "Odkaz musí mít příponu, ale nemůže to být .html nebo .php. Odkaz také nesmí obsahovat jazykovou cestu, např. \"/fr\"",
        "regex": "Regulární výraz je neplatný",
        "wildcard": "Odkaz se zástupným znakem má neplatný protokol"
      }
    },
    "main": {
      "parent": "Odkazy",
      "edit": "Upravit odkaz"
    }
  },
  "links": {
    "title": "Správa médií a externích odkazů",
    "description": "Vypsat a upravit vaše mediální nebo externí odkazy webu.",
    "add": "Přidat odkaz",
    "delete": "Smazat odkaz",
    "table": {
      "original": "Původní",
      "language": "Jazyk",
      "translation": "Překlad",
      "action": "Akce",
      "delete_confirm": "Potvrďte prosím smazání odkazu"
    }
  },
  "members": {
    "header": "Členové",
    "invite": "Pozvat nového člena",
    "modal": {
      "inviteHeader": "Pozvat nového člena",
      "editHeader": "Upravit člena",
      "detachHeader": "Odpojit člena",
      "detachBody": "Opravdu chcete odpojit člena od tohoto účtu?",
      "selfDetachBody": "Opravdu se chcete odpojit od správy tohoto účtu? Poté nebudete mít přístup k žádným datům souvisejícím s tímto účtem."
    },
    "table": {
      "title": "Seznam členů",
      "description": "Role členů a přístup k doménám",
      "name": "Jméno",
      "email": "E-mail",
      "websites": "Weby",
      "languages": "Jazyky",
      "role": "Role",
      "status": "Stav",
      "resendInvite": "znovu odeslat",
      "inviteSent": "pozvánka byla odeslána",
      "actions": "Akce",
      "edit": "Upravit",
      "detach": "Odpojit",
      "empty": "Zatím nemáte žádné členy",
      "all_website": "Všechny weby a jazyky",
      "roles": {
        "admin": "Administrátor",
        "manager": "Manažer",
        "translator": "Překladatel"
      },
      "statuses": {
        "pending": "Čeká",
        "accepted": "Přijato",
        "declined": "Odmítnuto"
      }
    },
    "errors": {
      "role": "Musíte vybrat roli",
      "domains": "Musíte vybrat alespoň 1 web pro vybranou roli",
      "languages": "Musíte vybrat alespoň 1 jazyk pro vybrané weby"
    },
    "inviteSent": "Vaše pozvánka byla úspěšně odeslána"
  },
  "pagination": {
    "showing": "Zobrazuje se {{limit}} z {{total}} výsledků",
    "showing_only_count": "Zobrazuje se {{limit}} výsledků"
  },
  "payments_method": {
    "header": "Platební metody",
    "table": {
      "title": "Seznam platebních metod",
      "description": "Platební metody připojené k vašemu účtu",
      "default": "Výchozí",
      "action_edit_remove": "Upravit nebo odstranit",
      "action_remove": "Odstranit",
      "action_default": "Nastavit jako výchozí",
      "action_fallback": "Nastavit jako záložní",
      "expires": "Platnost končí",
      "add_new_card": "Přidat platební metodu",
      "action_fallback_remove": "Odebrat ze zálohy",
      "fallback": "Záložní",
      "action_edit": "Upravit",
      "action_delete": "Smazat",
      "action_default_remove": "Odebrat jako výchozí",
      "domain_count@@one": "Používá {{count}} domén",
      "domain_count@@other": "Používáno {{count}} doménami"
    },
    "paypal_bind": {
      "button": "Připojit PayPal účet",
      "button_load": "Připojování…",
      "disconnected": "Nepřipojeno",
      "success": "Váš PayPal účet je nyní připojen, z následující faktury bude odečteno 5 $!",
      "success_no_promo": "Váš PayPal účet je nyní připojen",
      "error": "Vyskytla se chyba",
      "success_header": "Úspěch"
    },
    "card_add": {
      "header": "Přidat novou kartu",
      "success": "Nová karta byla připojena k Linguise!",
      "terms": "Poskytnutím údajů o kartě umožňujete společnosti Linguise účtovat vaši kartu za budoucí platby v souladu s našimi podmínkami služby."
    },
    "card_detail": {
      "header": "Informace o kartě",
      "delete": {
        "error": "Tuto platební metodu nelze smazat, protože má aktivní předplatná!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Předplatná na tuto platební metodu",
        "header_domain": "Doména",
        "header_plan": "Tarif",
        "header_status": "Stav",
        "header_actions": "Akce",
        "cancelling": "Zrušení k: {{0}}",
        "next_payment": "Další platba k: {{0}}",
        "action_renew": "Obnovit",
        "no_subs_header": "Žádná předplatná k zobrazení",
        "no_subs_desc": "Jakmile bude na tuto kartu vytvořeno předplatné, všechny informace se zobrazí zde",
        "action_manage": "Spravovat"
      },
      "status": {
        "active": "Aktivní",
        "canceled": "Zrušeno",
        "incomplete": "Nezaplaceno",
        "incomplete_expired": "Nezaplaceno (vypršelo)",
        "missing": "Chyba",
        "past_due": "Po splatnosti",
        "trialing": "Zkušební",
        "unpaid": "Nezaplaceno"
      }
    },
    "delete_confirm_body": "Opravdu chcete smazat tuto platební metodu? Tuto akci nelze vrátit!",
    "delete_confirm_header": "Smazat platební metodu?",
    "card_edit": {
      "header": "Upravit kartu",
      "billing_header": "Fakturační údaje",
      "address_error": "Adresa je povinná!",
      "card_number": "Číslo karty",
      "card_expiry": "Datum platnosti",
      "expiry_error_month": "Neplatný měsíc",
      "expiry_error_year": "Neplatný rok",
      "expiry_error_expired": "Datum platnosti vaší karty již uplynulo.",
      "card_header": "Údaje o kartě",
      "expiry_error_empty": "Toto pole je povinné!"
    }
  },
  "plans": {
    "per": "za",
    "wordsTranslated": "přeložených slov",
    "current": "Aktuální",
    "archived": "Archivováno",
    "day": "den",
    "week": "týden",
    "month": "měsíc",
    "year": "rok",
    "activate": "Aktivovat",
    "cancel": "Zrušit",
    "change": "Změnit",
    "upgrade": "Upgradovat",
    "downgrade": "Downgradovat",
    "resume": "Obnovit",
    "notEnoughWords": "Nedostatek slov",
    "yearIntervalOnly": "Z ročního tarifu nelze migrovat",
    "subsCanceled": "Právě probíhá zrušení jiného předplatného",
    "wordsUnlimited": "Neomezeně slov",
    "tabs": {
      "day": "Denní ceny",
      "week": "Týdenní ceny",
      "month": "Měsíční ceny",
      "year": "Roční ceny",
      "sub_texts": {
        "day": "Jedna pevná cena každý den",
        "week": "Jedna pevná cena každý týden",
        "month": "Jedna pevná cena každý měsíc",
        "year": "Jeden měsíc zdarma, jednou ročně faktura"
      }
    },
    "details": {
      "new_languages": "Přidávejte nové jazyky kdykoli",
      "one_month_trial": "Jeden měsíc zkušební doby zdarma pro každý nový web",
      "multi_content_indexed": "100 % vícejazyčného obsahu indexováno",
      "translate_new_content": "Překládejte nový obsah okamžitě",
      "free_installation": "Instalace a nastavení zdarma",
      "compared_monthly_plan": "Oproti měsíčním tarifům jeden měsíc zdarma",
      "risk_free_recurring": "Bezrizikové opakované selhání platby",
      "unlimited_languages": "Neomezené jazyky a zobrazení stránek",
      "high_server_resources": "Vysoké serverové zdroje",
      "billed": {
        "day": "Fakturace denně",
        "week": "Fakturace týdně",
        "month": "Fakturace měsíčně",
        "year": "Fakturace ročně"
      },
      "request_max_size": "Maximální velikost požadavku {{0}}"
    },
    "frequent_question": {
      "title": "Často kladené dotazy",
      "questions": {
        "trial": {
          "question": "Mohu vyzkoušet zkušební verzi na nové doméně webu?",
          "answer": "Ano, pro každou novou doménu, kterou přidáte do účtu, poskytujeme 30denní zkušební dobu zdarma. Službu tak můžete na novém webu plně vyzkoušet."
        },
        "seo": {
          "question": "Jak dlouho trvá, než se zlepší moje SEO?",
          "answer": "Obsah a vícejazyčný obsah potřebují čas na úplné zaindexování a dobré umístění. V závislosti na návštěvnosti a velikosti webu to trvá 3 až 6 týdnů."
        },
        "quota": {
          "question": "Jsou lidské překlady započítané do kvóty?",
          "answer": "Ne, limit slov se vztahuje pouze na automatické strojové překlady. Překladatel může automatické překlady ručně upravovat bez omezení."
        }
      }
    },
    "best_offer": "Nejlepší nabídka",
    "period": {
      "days@@one": "den",
      "days@@other": "{{count}} dny",
      "hours@@one": "hodina",
      "hours@@other": "{{count}} hodin",
      "minutes@@one": "minuta",
      "minutes@@other": "{{count}} minut",
      "seconds@@one": "sekunda",
      "seconds@@other": "{{count}} sekund"
    },
    "words": {
      "billion": "{{value}} mld",
      "million": "{{value}} mil",
      "thousand": "{{value}} tis"
    },
    "throttling_info": "{{words}} slov za {{period}}"
  },
  "profile": {
    "welcome": "Vítejte!",
    "account": "Můj účet",
    "subscriptions": "Předplatná",
    "logout": "Odhlásit se"
  },
  "register": {
    "errors": {
      "password": "Minimálně 8 znaků, libovolné znaky"
    }
  },
  "route": {
    "dashboard": "Přehled",
    "rules": "Pravidla",
    "translations": "Překlady",
    "search_translations": "Vyhledávací dotazy",
    "urls_translations": "Překlady URL",
    "links": "Média a externí odkazy",
    "online_editor": "Živý editor",
    "settings": "Nastavení",
    "domain": {
      "finish": "Nastavení",
      "preconfig": "Nastavení"
    },
    "home": "Domů",
    "domain_list": "Seznam domén",
    "members": "Členové",
    "invoices": "Faktury",
    "billing": "Fakturační údaje",
    "language_display": "Zobrazení jazykových vlaječek",
    "payment_methods": "Platební metody",
    "ai_translation": "AI překlad",
    "ai_translation_settings": "Nastavení",
    "ai_translation_pricing": "Ceny"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Text k ignorování",
        "add": "Přidat nový",
        "title": "Text k ignorování",
        "description": "Přidejte jeden nebo více textů k ignorování",
        "ignore_case": "Ignorovat velikost písmen"
      },
      "html_content": {
        "title": "Použít na HTML obsah",
        "description": "Použít pravidlo na celý obsah nebo vybrat konkrétní CSS selektor",
        "all_page": "Celá stránka",
        "css_selector": "CSS selektor",
        "label": "CSS selektor",
        "placeholder": "Selektor k použití",
        "add": "Přidat nový"
      },
      "apply_to_urls": {
        "title": "Použít na URL",
        "description": "Vyberte konkrétní URL, na kterých se má pravidlo použít",
        "all_urls": "Všechny URL",
        "selected_urls": "Vybrané URL",
        "label": "URL pro aplikaci",
        "placeholder": "URL pro aplikaci",
        "original_url": "Původní URL",
        "translated_url": "Přeložená URL",
        "wildcard": "Zástupný znak",
        "regex": "Regulární výraz",
        "add": "Přidat nový",
        "expression": "Typ výrazu"
      },
      "apply_urls": {
        "title_exclude": "Vyloučit z URL",
        "title_replace": "Nahradit v URL",
        "title_description": "Použít toto pravidlo také na překlad URL"
      },
      "apply_languages": {
        "title": "Použít na jazyky",
        "description": "Vyberte konkrétní jazyky, na které se má pravidlo vztahovat",
        "all_languages": "Všechny jazyky",
        "selected_languages": "Vybrané jazyky",
        "placeholder": "Vyberte jazyky…",
        "feedback": "Musíte vybrat jazyk"
      },
      "name": {
        "title": "Název",
        "description": "Pojmenujte své pravidlo pro přehlednost",
        "placeholder": "Název pravidla"
      },
      "type": {
        "title": "Typ",
        "description": "Vyberte typ pravidla, které chcete přidat",
        "text_ignore": "Ignorovat text",
        "text_replace": "Nahradit text",
        "content_exclusion": "Vyloučení obsahu",
        "url_exclusion": "Vyloučení podle URL",
        "ignore_inline": "Ignorovat inline",
        "full_description": {
          "text_ignore": "Přidejte pravidla, aby se určitý text nepřekládal. Může to být název produktu, značky nebo jiné technické prvky, které nechcete překládat.",
          "text_replace": "Nahrazení textu umožňuje nahradit určitý text překladem, který požadujete; je to užitečné, když překlad nezohledňuje kontext.",
          "content_exclusion": "Vyloučení obsahu vám pomůže zabránit překladu určitého obsahu na stránce.\nChcete-li celou stránku zcela vyloučit z překladu (žádná vícejazyčná URL a žádný přeložený obsah), použijte typ „Vyloučení podle URL“.",
          "url_exclusion": "Vyloučení překladu stránky vám umožní nastavit stránky, které nechcete překládat.",
          "ignore_inline": "Zabraňte překladu části obsahu jako inline; místo toho překládejte každou značku zvlášť."
        }
      },
      "text_replace": {
        "title": "Text k nahrazení",
        "description": "Nahraďte určitý text vaším vlastním překladem. Kdekoliv na stránkách, podle jazyka…",
        "text_to_replace": "Text k nahrazení",
        "ignore_case": "Ignorovat velikost písmen",
        "text_type": "Nahrazení v překladu",
        "text_type_original": "Původní",
        "text_type_translation": "Překlad",
        "keep_case": "Zachovat velikost písmen",
        "add": "Přidat nový"
      },
      "content_exclusion": {
        "title": "Vyloučení obsahu",
        "description": "Vyberte jeden nebo více CSS selektorů, které se nebudou překládat",
        "label": "CSS selektor",
        "placeholder": "Selektor pro aplikaci",
        "add": "Přidat nový"
      },
      "multilingual_url": {
        "title": "Použít vícejazyčnou URL",
        "description": "Pokud je nastaveno Ano, URL se nebude překládat, ale stránka zůstane vícejazyčná s přeloženým obsahem",
        "live_example_title": "Živý příklad",
        "live_example_description": "Zdrojová URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Vygenerovaná URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Vygenerovaná URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Použijte pravidlo na statický obsah, dynamický obsah nebo na oba",
        "title": "Použít na obsah",
        "all": "Veškerý obsah",
        "static": "Statický obsah",
        "dynamic": "Dynamický obsah"
      },
      "force_apply_urls": {
        "title_description": "Násilně použít toto pravidlo na veškeré překlady URL, včetně existujících!",
        "title_replace": "Vynutit nahrazení v URL",
        "title_exclude": "Vynutit vyloučení v URL",
        "warning": "Varování",
        "warning_part1": "Nastavení na „Ano“ může rozbít překlady URL vašeho webu.",
        "warning_part2": "Může to dočasně nebo trvale způsobit chyby 404; pokračujte pouze v případě, že chápete následky.",
        "warning_replacement_original": "Další varování: Pokoušíte se nahradit původní obsah, který může ovlivnit URL; překlad může selhat, protože Linguise nemůže správně najít původní URL."
      }
    },
    "main": {
      "parent": "Pravidla",
      "edit": "Upravit pravidlo",
      "add": "Nové pravidlo"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "„{{text_ignore}}“ bude ignorováno v obsahu a v URL",
      "preview_single": "„{{text_ignore}}“ bude ignorováno v obsahu",
      "preview_more_with_url": "„{{text_ignore}}“ a {{count}} dalších bude ignorováno v obsahu",
      "preview_more": "„{{text_ignore}}“ a {{count}} dalších bude ignorováno v obsahu",
      "other_parameters": "Pro toto pravidlo jsou nastaveny další parametry; klikněte na tlačítko úprav pro více informací"
    },
    "text_replace": {
      "preview_single_with_url": "„{{original}}“ je nahrazeno „{{replacement}}“ v obsahu a URL",
      "preview_single": "„{{original}}“ je nahrazeno „{{replacement}}“ v obsahu",
      "preview_more_with_url": "„{{original}}“ je nahrazeno „{{replacement}}“ v obsahu a URL a {{nb}} dalších",
      "preview_more": "„{{original}}“ je nahrazeno „{{replacement}}“ v obsahu a {{nb}} dalších",
      "other_parameters": "Pro toto pravidlo jsou nastaveny další parametry; klikněte na tlačítko úprav pro více informací"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS selektorů je vyloučeno z překladu",
      "other_parameters": "Pro toto pravidlo jsou nastaveny další parametry; klikněte na tlačítko úprav pro více informací"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL je vyloučeno z překladu, ale zachovávají vícejazyčnou předponu",
      "some": "{{nb}} URL je zcela vyloučeno z překladu",
      "all_multilingual": "všechny URL jsou vyloučeny z překladu, ale zachovávají vícejazyčnou předponu",
      "all": "všechny URL jsou zcela vyloučeny z překladu",
      "other_parameters": "Pro toto pravidlo jsou nastaveny další parametry; klikněte na tlačítko úprav pro více informací"
    },
    "ignore_inline": {
      "elements": "Veškerý inline obsah bude překládán jako blokový obsah na stránce",
      "all_elements": "Část inline obsahu bude překládána jako blokový obsah na stránce",
      "other_parameters": "Pro toto pravidlo jsou nastaveny další parametry, kliknutím na tlačítko Upravit zobrazíte další informace."
    },
    "title": "Správa pravidel",
    "description": "Spravujte vyloučení a nahrazení překladů obsahu na celém webu",
    "add": "Přidat nové pravidlo",
    "table": {
      "title": "Název",
      "no_data": "Zatím zde nejsou žádná pravidla",
      "type": "Typ",
      "preview": "Náhled pravidla",
      "action": "Akce",
      "delete_confirm": "Potvrďte prosím smazání pravidla",
      "types": {
        "text_ignore": "Ignorovat text",
        "text_replace": "Nahradit text",
        "content_exclusion": "Vyloučení obsahu",
        "url_exclusion": "Vyloučení URL",
        "ignore_inline": "Ignorovat inline",
        "unknown": "Neznámé pravidlo"
      }
    },
    "apply_on_content": {
      "static": "Toto pravidlo bude použito pouze na statický obsah",
      "dynamic": "Toto pravidlo bude použito pouze na dynamický obsah"
    }
  },
  "search_translations": {
    "title": "Správa vyhledávacích dotazů",
    "description": "Seznam všech překladů vašeho webu použitých ve vyhledávacích formulářích (z přeloženého jazyka do základního jazyka vaší domény)",
    "filter_languages": "Filtrovat podle jazyků...",
    "filter_original": "Filtrovat text v původním jazyce",
    "filter_translation": "Filtrovat podle přeloženého textu",
    "table": {
      "original": "Původní",
      "language": "Jazyk",
      "translation": "Překlad"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Předplatné se nepodařilo aktivovat!",
      "title": "Předplatné se nepodařilo aktivovat!",
      "subtitle": "Při zpracování vašeho předplatného došlo k chybě.",
      "home": "Zpět na hlavní stránku",
      "generic": "Na straně Linguise došlo k neznámé chybě, kontaktujte prosím administrátora!"
    },
    "success": {
      "home": "Spravovat překlady domény",
      "message": "Zavazujeme se vám poskytnout ten nejlepší možný zážitek z překladu. Náš tým odborníků je vám k dispozici s jakýmikoli otázkami nebo podporou, kterou potřebujete. Chcete-li začít, jednoduše klikněte na tlačítko níže.",
      "subtitle": "Děkujeme, že jste si vybrali překladatelskou službu Linguise",
      "title": "Předplatné aktivováno!",
      "tab_title": "Děkujeme za předplatné!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Předplatné aktivováno!",
      "title": "Předplatné aktivováno!",
      "subtitle": "Děkujeme, že jste si vybrali překladatelskou službu Linguise",
      "message": "Zavazujeme se vám poskytnout ten nejlepší možný zážitek z překladu. Náš tým odborníků je vám k dispozici s jakýmikoli otázkami nebo podporou, které potřebujete. Chcete-li začít, jednoduše klikněte na tlačítko níže.",
      "home": "Spravovat překlady domény"
    },
    "edit": {
      "title": "Spravovat předplatné"
    },
    "list": {
      "title": "Seznam předplatných",
      "description": "Seznam předplatných vaší domény"
    },
    "table": {
      "domain": "Doména",
      "plan": "Tarif",
      "status": "Stav",
      "card": "Karta",
      "usage": "Využití",
      "actions": "Akce",
      "payment_method": "Způsob platby"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} slov",
      "paidOffered": "{{words_used}} / {{words_allowed}} slov\n(Zahrnuje {{free_words}} nabídnutých slov)"
    },
    "popup": {
      "dueToday": "Celkem splatné dnes",
      "nextPeriod": "Počínaje {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Vyberte účet"
    }
  },
  "translation": {
    "main": {
      "parent": "Překlady",
      "edit": "Upravit překlad"
    },
    "form": {
      "original": {
        "title": "Původní v {{language}}"
      },
      "is_inline": "Tento překlad je vytvořen z inline obsahu.",
      "inline_editor": {
        "count_warning": "Počet vložených oblastí neodpovídá originálu ({{current}} z {{expected}}).",
        "restore_original": "Obnovit původní text",
        "insert_placeholder": "Vložit zástupný text",
        "drag": "Přetažením změňte pořadí vložené oblasti",
        "area": "Vložená oblast {{index}}",
        "restore": "Obnovit chybějící vložené oblasti"
      },
      "translation": {
        "title": "Překlad v {{language}}",
        "description": "Překlad, který chcete přepsat"
      }
    },
    "copy": {
      "title": "Zkopírovat do ručního překladu",
      "label": "Kopírovat do ručního"
    },
    "level": {
      "base": {
        "title": "Základní překlad",
        "subtitle": "Automatický · překlad Linguise Cloud",
        "empty": "Pro tento text neexistuje základní překlad.",
        "overridden": "Váš výběr je uložen, ale místo něj se zobrazuje nejnovější AI vylepšený překlad, protože „Přepsat ruční a vybrané překlady“ je v nastavení AI překladu nastaveno na Ano. Chcete-li použít svůj výběr, toto nastavení vypněte."
      },
      "not_generated": "Nevygenerováno",
      "none": "Zatím nic",
      "ai": {
        "title": "AI vylepšený překlad",
        "subtitle": "Automatický · Linguise AI",
        "empty_title": "Pro tento text zatím nevygenerováno",
        "empty_description": "Linguise AI vytváří přirozenější překlady díky kontextu vaší stránky i webu. Chcete-li ho zde získat:",
        "empty_step_1": "Přejděte do AI překlad › Nastavení a nastavte Povolit AI překlad na „Pouze pravidla“, „Pouze živý editor“ nebo „Pravidla a živý editor“.",
        "empty_step_2": "Použijte jej pomocí pravidla, které odpovídá této stránce, nebo jej zapněte stránku po stránce v živém editoru.",
        "empty_step_3": "AI vylepšený překlad se zde zobrazí po vygenerování. Spotřebovává vaše AI kredity.",
        "open_settings": "Otevřít nastavení AI překladu",
        "open_editor": "Otevřít živý editor",
        "overrides_selection": "Váš výběr je uložen, ale místo něj se zobrazuje tento AI vylepšený překlad, protože „Přepsat ruční a vybrané překlady“ je v nastavení AI překladu nastaveno na Ano. Chcete-li použít svůj výběr, toto nastavení vypněte.",
        "overrides_version": "Vámi vybraná verze je uložena, ale místo ní se zobrazuje nejnovější AI vylepšená verze, protože „Přepsat ruční a vybrané překlady“ je v nastavení AI překladu nastaveno na Ano. Chcete-li použít vybranou verzi, toto nastavení vypněte."
      },
      "manual": {
        "title": "Ruční překlad",
        "subtitle": "Napsáno vámi · má přednost před automatickými překlady",
        "empty": "Prázdné",
        "saved_but_overridden": "Uloženo jako vaše volba, ale automaticky se nezobrazuje, protože „Přepsat ruční překlady“ je v nastavení AI překladu nastaveno na Ano: AI vylepšený překlad má přednost, dokud toto nastavení nevypnete.",
        "ignored": "Automaticky se nezobrazuje, protože „Přepsat ruční překlady“ je v nastavení AI překladu nastaveno na Ano. Vyberte jej, pokud ho chcete pro tento text použít.",
        "label": "Váš překlad",
        "placeholder": "Napište vlastní překlad...",
        "last_updated": "Naposledy upraveno {{date}}",
        "save_hint": "Uložením ručního překladu se stane aktivním.",
        "delete": "Smazat ruční překlad",
        "delete_confirm": "Potvrďte prosím smazání ručního překladu"
      }
    },
    "history": {
      "title": "AI vylepšené verze",
      "subtitle": "Každé opětovné vygenerování z živého editoru se uchovává",
      "unknown_model": "Neznámý model",
      "current": "Aktuální",
      "restore": "Obnovit tuto verzi",
      "restore_note": "Obnovením se tato verze stane aktuálním AI vylepšeným překladem. Nic se nemaže.",
      "version_of": "Verze {{current}} z {{total}}",
      "hide": "Skrýt historii ({{total}})",
      "show": "Zobrazit historii ({{total}})"
    },
    "choose": {
      "title": "Překlady do jazyka {{language}} · vyberte ten, který uvidí návštěvníci",
      "current": "Aktuálně na vašem webu:",
      "priority": "Výchozí priorita: Ruční › AI vylepšený › Základní. Vaše volba se uloží pouze pro tento překlad.",
      "reset": "Obnovit výchozí prioritu",
      "reset_title": "Zapomenout váš výběr pro tento text a znovu použít výchozí prioritu",
      "resetting": "Obnovování..."
    }
  },
  "translations": {
    "title": "Správa překladů",
    "description": "Seznam a úprava všech překladů vašeho webu; pro vizuální překlad použijte Live Editor",
    "filter_languages": "Filtrovat podle jazyků...",
    "filter_original": "Filtrovat text v původním jazyce",
    "filter_translation": "Filtrovat podle přeloženého textu",
    "table": {
      "original": "Původní",
      "language": "Jazyk",
      "action": "Akce",
      "base": "Základní",
      "ai": "AI vylepšený",
      "manual": "Ruční"
    },
    "filter_exact": "Přesná shoda",
    "badge": {
      "active": "Aktivní",
      "overrides_manual": "Přepisuje ruční"
    },
    "cell": {
      "none": "žádný",
      "not_generated": "nevygenerováno",
      "ignored": "Ignorováno – vyhrává AI pravidlo"
    },
    "tabs": {
      "all": "Vše",
      "manual": "S ručním",
      "ai": "S AI vylepšeným",
      "base": "Pouze základní"
    },
    "levels_hint": "Každý text má až 3 úrovně — ta označená jako Aktivní je ta, kterou vidí návštěvníci."
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "Upravit překlad URL"
    },
    "form": {
      "original": {
        "title": "Původní v {{language}}"
      },
      "translation": {
        "title": "Překlad URL v {{language}}",
        "description": "URL, které chcete přepsat",
        "placeholder": "Přepsání překladu URL",
        "invalid_full": "Pokoušíte se změnit na nesprávný formát; měli byste měnit pouze slugy/cestu v překladu URL",
        "invalid": "Byla zadána neplatná URL/cesta"
      }
    }
  },
  "urls": {
    "title": "Správa URL",
    "description": "Seznam a úprava všech přeložených URL vašeho webu (pokročilé; dávejte pozor na chyby 404)",
    "filter_languages": "Filtrovat podle jazyků...",
    "filter_original": "Filtrovat text v původním jazyce",
    "filter_translation": "Filtrovat podle přeloženého textu",
    "table": {
      "original": "Původní",
      "language": "Jazyk",
      "url": "Přeložená URL",
      "action": "Akce",
      "edited": "Původní překlad byl upraven"
    }
  }
}
